module.exports = __webpack_public_path__ + "static/media/audit.1e5abab5.svg";